import React from 'react';

import Image from '../../Image';
import Container from '../../interface/Container';
import BlockWrapper from '../BlockWrapper';
import { Content, CtaButton, CtaButtonWrapper, ImageWrapper, Split, Text, Title } from './TwoColumnImage.styles';

const TwoColumnImageBlock = ({ block, bigTitle }) => {
  const { mainTitle, text, image, position, linkTitle, ctaUrl } = block;

  return (
    <BlockWrapper>
      <Container>
        <Split imagePosition={position}>
          {image && (
            <ImageWrapper>
              <Image image={image?.[0]} />
            </ImageWrapper>
          )}
          <Content>
            <Title bigTitle={bigTitle}>{mainTitle}</Title>
            <Text dangerouslySetInnerHTML={{ __html: text }} />
            {linkTitle && ctaUrl && (
              <CtaButtonWrapper>
                <CtaButton href={ctaUrl.url} type={ctaUrl.type} size="large">
                  {linkTitle}
                </CtaButton>
              </CtaButtonWrapper>
            )}
          </Content>
        </Split>
      </Container>
    </BlockWrapper>
  );
};

export default TwoColumnImageBlock;
